import moment from "moment";
import getLookups from "../views/Config/lookups";

const { countries, headTraumaChecks } = getLookups();

// This is called to clear the persisted data in localStorage for the questionnaire form
export default function clear() {
  const state = JSON.parse(localStorage.getItem("persist:root"));
  const questionnaire = initState;
  const _persist = state["_persist"];
  const newState = JSON.stringify({ questionnaire, _persist });
  return localStorage.setItem("persist:root", newState);
}

const initState = {
  name: "",
  email: "",
  cellPhone: "",
  homePhone: "",
  isFrequentCaller: false,
  isVeteran: false,
  veteranBranch: "",
  yearsOfMilitaryService: "",
  isDisabled: false,
  receivedVaTreatment: false,
  gender: "male",
  veteranRank: "",
  yearsOfPoliceService: "",
  country: countries[0],
  provinceState: "",
  city: "",
  departmentSize: "",
  callerType: "",
  age: "",
  coplineReferral: "",
  impairment: "",
  currentStruggle: "",
  callStart: moment(),
  callEnd: moment(),
  callReason: "",
  isSuicidalCall: false,
  callWasReferred: false,
  referralDetails: "",
  returnCall: false,
  returnCallDate: null,
  returnCallDetails: "",
  returnCallFollowUpNotes: "",
  originCallReportId: 0,
  callType: "ORIGIN",
  combatExperience: false,
  treatedForPtsd: false,
  other_medical_condition: false,
  headTraumaCheck: headTraumaChecks.REPORTED,
  headTrauma: [],
  // async
  loading: {},
  error: {},
  success: {},
};
